// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__nBKBu","title":"FrontImage_title__1w5dr"};